(ns teamoesterreich.admin-mode.user.document-assign-modal
  (:require [reagent-material-ui.components :as mui]
            [reagent-material-ui.icons.keyboard-arrow-left :refer [keyboard-arrow-left]]
            [reagent-material-ui.icons.save :refer [save]]  ;;(h/event-value e)
            [reagent.core :as r]
            [teamoesterreich.setup :refer [USER_DOCUMENT_TYPES]]
            [teamoesterreich.admin-mode.data.backend :as backend]
            [teamoesterreich.admin-mode.data.user :as d-user]
            [teamoesterreich.admin-mode.data.user :as s-user]
            [teamoesterreich.element.backend-file :as backend-file]
            [teamoesterreich.util.helper :as h]
            [teamoesterreich.util.log :as log]))




(defn change-type [user-uuid document type cb-fn]
  (log/debug "change-type " user-uuid document type)
  (s-user/>user-edit-document-field (:userDocument-uuid document) {:userDocument-type (str type)} cb-fn)
  (when (= type "profilePicture") (d-user/>user-edit-field user-uuid
                                                           {:user-portraitFileHash (:userDocument-path document)
                                                            :user-fsPortraitPath   ""
                                                            :invalidatePortrait    true
                                                            }
                                                           cb-fn))
  )

(defn modal [!actual-user {:keys [userDocument-uuid userDocument-type userDocument-fileName userDocument-path userDocument-active userDocument-readonly uploaded] :as document} !show]
  (let [!new-type (r/atom (or userDocument-type ""))
        user-uuid (:user-uuid @!actual-user)]
    (fn []
      [mui/modal
       {
        :aria-labelledby  "simple-modal-title"
        :aria-describedby "simple-modal-description"
        :style            {:display        "flex"
                           :marginRight    "auto"
                           :marginLeft     "auto"
                           :alignItems     "center"
                           :justifyContent "center"}
        :open             (or @!show false)

        }
       [:div
        {
         :class "modal"
         :style {:width 600}}
        [:h2 "Dokument zuordnen"]


        [backend-file/img {:hash             userDocument-path
                                  :preview? true
                                  :style    {:position "relative" :float "right" :maxHeight "150px"}
                                  :alt      "Ansicht"}]

        [:div {:style {:width "calc(100% - 202px)"}}
         [mui/typography {:gutterBottom true :style {}} (or (get USER_DOCUMENT_TYPES userDocument-type) (str "? " userDocument-type))]
         [:br]
         [mui/typography {} (or userDocument-fileName userDocument-path)]
         ]

        [:br]
        [:br]
        [:br]
        [:br]
        [mui/form-label "Dokument Typ ändern"
         [mui/select
          {:fullWidth true
           :style     {:backgroundColor (if (not= @!new-type (or userDocument-type "")) "#ffd6d2" "#ffffff")}
           :value     @!new-type
           :onChange  (fn [e]
                        (log/debug " new-type " (h/event-value e))
                        (reset! !new-type (h/event-value e)))
           :label     "Dokumenttyp"}
          (for [[key name] USER_DOCUMENT_TYPES]
            [mui/menu-item {:key (str "docType_" key) :value key} name]
            )
          ]]


        [:br]
        [:br]
        [:br]
        [mui/button
         {:variant   "contained"
          :startIcon (r/as-element [keyboard-arrow-left])
          :style     {:marginRight 50}
          :onClick   #(reset! !show false)
          }
         "Abbrechen"]
        [mui/button
         {:color     "primary"
          :disabled  (= @!new-type (or userDocument-type ""))
          :style     {:float "right"}
          :variant   "contained"
          :startIcon (r/as-element [save])
          :onClick   (fn []
                       (change-type user-uuid document @!new-type (fn []
                                                                    (s-user/actual-user-invalidate !actual-user)
                                                                    (reset! !show false)
                                                                    ))
                       )
          }
         "Speichern"]]
       ]
      )))

